import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { initSentry } from './app/sentry.js';
import { AppProviders } from './app/providers.js';
import { AppRouter } from './app/router.js';
// Canonical branded-scale runtime CSS-var layer (--brand-*/--success-*/
// …/--radius-*) from the shared token package. Imported before
// index.css, which layers the app's SEMANTIC tokens on top.
import '@sparta/design-tokens/tokens.css';
import './index.css';

initSentry();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error(
    "apps/admin: #root element missing in index.html — bootstrap aborted.",
  );
}

createRoot(rootEl).render(
  <React.StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </React.StrictMode>,
);
